import { Amplify } from "aws-amplify";

export const initAmplify = () => {
  let config = {
    Auth: {
      region: process.env.REACT_APP_AWS_REGION, // Use prefixed environment variables
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID, // Use prefixed environment variables
      userPoolWebClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID, // Use prefixed environment variables
    },
  };
 
  Amplify.configure(config);
};




 
 

 

/** Custom Auth implementation */

const doStepOne = async (email: string) => {


  var options = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
    },
    body: `{\n    "AuthParameters" : {\n        "USERNAME": "${email}"\n    },\n    "AuthFlow" : "CUSTOM_AUTH", \n    "ClientId" : "${process.env.REACT_APP_COGNITO_WEB_CLIENT_ID}"\n   \n}`
  };

 
  const response = await fetch(
    "https://cognito-idp.ap-southeast-2.amazonaws.com/",
    options
  );
  const data = await response.json();
  // console.log("step1", JSON.stringify(data));

  return data;

};

const doStepTwo = async (session: string, answer: string, username: string, data: any) => {
 

  var options = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-amz-json-1.1",
      "X-Amz-Target": "AWSCognitoIdentityProviderService.RespondToAuthChallenge",
    },
  //  body: `{\n\n   "ClientId" : "${REACT_APP_COGNITO_WEB_CLIENT_ID}",\n    "ChallengeName": "CUSTOM_CHALLENGE",\n    "ChallengeResponses": {\n        "USERNAME": "${username}",\n        "ANSWER":"${answer}"\n    },\n    "Session":"${session}",\n     "ClientMetadata":{\n        "dob": "${data.dateOfBirth}",\n        "fname": "${data.firstName}",\n        "lname": "${data.secondName}",\n        "email": "${data.email}",\n        "phone": "${data.phoneNumber.replace(/\s/g, '')}"\n    }\n}`,
    body:`{

      "ClientId" : "${process.env.REACT_APP_COGNITO_WEB_CLIENT_ID}",
        "ChallengeName": "CUSTOM_CHALLENGE",
        "ChallengeResponses": {
            "USERNAME": "${username}",
            "ANSWER":"${answer}"
        },
        "Session":"${session}",
        "ClientMetadata":{
            "dob": "${data.dateOfBirth}",
            "fname": "${data.firstName}",
            "lname": "${data.secondName}",
            "email": "${data.email}",
            "birthSex": "${data.birthSex}",
            "phone": "${data.phoneNumber.replace(/\s/g, '')}"
        }
        
    }` 

};
  const response = await fetch(
    "https://cognito-idp.ap-southeast-2.amazonaws.com/",
    options
  );
  const payload = await response.json();
  //  console.log("step2", JSON.stringify(payload));
  payload.statusCode = response.status;
  return payload;
};


const processTokens = (username, data) => {
  const itemPrefix = "CognitoIdentityServiceProvider." + process.env.REACT_APP_COGNITO_WEB_CLIENT_ID + "." + username;
  localStorage.setItem(itemPrefix + ".clockDrift", "0");
  localStorage.setItem(itemPrefix + ".accessToken", data?.AuthenticationResult?.AccessToken);
  localStorage.setItem(itemPrefix + ".idToken", data?.AuthenticationResult?.IdToken);
  localStorage.setItem(itemPrefix + ".refreshToken", data?.AuthenticationResult?.RefreshToken);
  localStorage.setItem(itemPrefix + ".deviceGroupKey", data?.AuthenticationResult?.NewDeviceMetadata?.DeviceGroupKey);
  localStorage.setItem(itemPrefix + ".deviceKey", data?.AuthenticationResult?.NewDeviceMetadata?.DeviceKey);
  localStorage.setItem("CognitoIdentityServiceProvider." + process.env.REACT_APP_COGNITO_WEB_CLIENT_ID  + ".LastAuthUser", username);
  localStorage.setItem("amplify-signin-with-hostedUI","false");
}


const doCustomAuth = async (userData: any) => {
  const result1 = await doStepOne(userData?.email);
  let username = result1?.ChallengeParameters?.USERNAME;
  const session1 = result1?.Session;
 
  if (result1?.ChallengeName === "CUSTOM_CHALLENGE") {

    if ("code" in result1?.ChallengeParameters) {
      // New class b registration
      const answer = result1?.ChallengeParameters?.code;
      username = result1?.ChallengeParameters?.USERNAME;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const resultX = await doStepTwo(session1, answer, username, userData);
      // Ignore the result - should be a auth fail as user is created.
      const result3 = await doStepOne(userData?.email);
      const session2 = result3?.Session;
      username = result3?.ChallengeParameters?.USERNAME;
      
      if ("mobile" in result3?.ChallengeParameters) {
        // Existing Class B user
        const answer = userData.phoneNumber.replace(/\s/g, '');
        const result4 = await doStepTwo(session2, answer, username, userData);
        if (result4.statusCode !== 200 ){
          return { result: "error", error: result4.message }
        } else {
          // console.log("Success - setting cookies for new user", JSON.stringify(result4));
          processTokens(username, result4);
          
          return {"result":"success"}
        }
        
      } else {
        //Something has gone wrong
        return { result: "error", error: "Error registering new user" }
      }
    } else if ("mobile" in result1?.ChallengeParameters) {
      // Existing Class B user
      const answer = userData.phoneNumber.replace(/\s/g, '');
      const result2 = await doStepTwo(session1, answer, username, userData);
      // console.log("Success - setting cookies for exsiting user", JSON.stringify(result2));
      if (result2.statusCode !== 200 ){
        return { result: "error", error: result2.message }
      } else {
        // console.log("Success - setting cookies for existing user", JSON.stringify(result2));
        processTokens(username, result2);
        return {"result":"success"}
      }
    } else if ("password" in result1?.ChallengeParameters) {
      // Exisiting first class user  
      return { result: "domfa" };
    }
  }
  return { result: "error", error: "Error authenticating user" }
}


interface AuthResult {
  result: string;
  error?: string;
}


class AmplifyService {

  detailsSignIn = async (userData: any): Promise<AuthResult> => {
    return await doCustomAuth(userData)
  };

  signIn = (signInData: any) => {
    return Amplify.Auth.signIn(signInData);
  };

  confirmSignIn = async (challenge: string, user: any, options: any) => {
    return Amplify.Auth.confirmSignIn(user, challenge);
  };

  forgotPassword = (username: string) => {
    return Amplify.Auth.forgotPassword(username);
  };

  forgotPasswordSubmit = async (
    username: string,
    code: string,
    newPassword: string
  ) => {
    return Amplify.Auth.forgotPasswordSubmit(username, code, newPassword);
  };

  changePassword = async (oldPassword: string, newPassword: string) => {
    try {
      const user = await Amplify.Auth.currentAuthenticatedUser();
      return Amplify.Auth.changePassword(user, oldPassword, newPassword);
    } catch (err) {
      console.log(err);
    }
  };
}

export default AmplifyService;
